module.exports = __webpack_public_path__ + "img/share-code.5507356e.jpg";